import React from 'react';
import BaseTooltip from 'components/Tooltip';

export interface Props {
  description: string,
  parent: HTMLElement,
  isTooltipActive: boolean,
  tooltipData: any,
  tooltipPos?: string,
  tooltipTimeout?: any,
}

export default function Tooltip({
  description,
  isTooltipActive,
  parent,
  tooltipData,
  tooltipPos,
  tooltipTimeout,
}: Props) {
  if (!(parent)) {
    return null;
  }
  if ((description?.length ?? 0) <= 0) {
    return null;
  }
  return (
    <BaseTooltip
      data={tooltipData}
      active={isTooltipActive}
      parent={parent}
      tooltipPos={tooltipPos}
      tooltipTimeout={tooltipTimeout}
    />
  );
}